export const adminUsersColumns = [
  { title: "administrator.user.header.name", columnKey: "name", sortable: true },
  { title: "administrator.user.header.email", columnKey: "email", sortable: true },
  { title: "Phone", columnKey: "phone", sortable: false },
  { title: "administrator.user.header.role", columnKey: "role", sortable: false },
  { title: "Actions", columnKey: "actions" },
];

export const emailBrandColumns = [
  { title: "Display Name", columnKey: "displayName", sortable: true },
  { title: "logo Id", columnKey: "logoId", sortable: true },
  { title: "Styles", columnKey: "styles", sortable: false },
  { title: "BrandId", columnKey: "brandId", sortable: false },
  { title: "Actions", columnKey: "actions" },
];

export const leadsManagementColumns: any = [
  { title: "", columnKey: "selectLeads" },
  { title: "Lead", columnKey: "name" },
  { title: "Email", columnKey: "email" },
  { title: "Phone Number", columnKey: "phone" },
  { title: "Skills", columnKey: "skills" },
  { title: "Created", columnKey: "createdAt" },
  { title: "Status", columnKey: "status" },
  { title: "Address", columnKey: "address", displayed: false },
  { title: "", columnKey: "sources" },
];

export const leadsManagementProfileLinksColumns: any = [
  { title: "Profile Link", columnKey: "profileLink" },
  { title: "Source", columnKey: "source" },
];

export const communicationHistoryColumns: any = [
  { title: "Type", columnKey: "type" },
  { title: "Sent on", columnKey: "createdAt" },
  { title: "Message", columnKey: "message" },
];

export const screeningQuestionTypesColumns = [
  { title: "administrator.categories.concept", columnKey: "name" },
  { title: "administrator.categories.localName", columnKey: "locale" },
  { title: "Actions", columnKey: "actions" },
];

export const offerTemplatesColumns = [
  { title: "Template Name", columnKey: "name" },
  { title: "creator.knockout.actions", columnKey: "actions" },
];

export const videoTypesColumns = [
  { title: "administrator.categories.concept", columnKey: "name" },
  { title: "administrator.categories.localName", columnKey: "localeName" },
  { title: "creator.knockout.actions", columnKey: "actions" },
];

export const categoriesTableColumns = [
  { title: "administrator.categories.concept", columnKey: "name" },
  { title: "administrator.categories.localName", columnKey: "localeName" },
  { title: "administrator.categories.industry", columnKey: "industry" },
  { title: "administrator.categories.local", columnKey: "isLocal" },
  { title: "administrator.categories.global", columnKey: "global" },
  { title: "administrator.categories.kernelId", columnKey: "kernelId" },
  { title: "", columnKey: "actions" },
];

export const tenantTagsColumns = [
  { title: "administrator.categories.concept", columnKey: "name", sortable: true },
  { title: "administrator.categories.localName", columnKey: "tagLanguage", sortable: false },
  { title: "administrator.tags.standard", columnKey: "isStandard", sortable: false },
  { title: "administrator.user.permissions.categoryTag", columnKey: "categoryTag" },
  { title: "creator.knockout.actions", columnKey: "actions" },
];

export const globalTagsColumns = [
  { title: "administrator.categories.concept", columnKey: "name", sortable: true },
  { title: "administrator.user.permissions.categoryTag", columnKey: "categoryTag" },
  { title: "administrator.tags.standard", columnKey: "isStandard" },
  { title: "creator.knockout.actions", columnKey: "actions" },
];

export const screeningAttributesColumns = [
  { title: "administrator.categories.concept", columnKey: "name", sortable: true },
  { title: "administrator.categories.localName", columnKey: "localeName" },
  { title: "creator.knockout.question", columnKey: "question" },
  { title: "administrator.screeningQuestionAttribute.localeQuestion", columnKey: "localeQuestion" },
  { title: "creator.knockout.actions", columnKey: "actions" },
];

export const globalScreeningAttributesColumns = [
  { title: "administrator.categories.concept", columnKey: "name", sortable: true },
  { title: "creator.knockout.question", columnKey: "question" },
  { title: "creator.knockout.actions", columnKey: "actions" },
];

export const refCheckLibraryColumns = [
  { title: "creator.knockout.question", columnKey: "question", sortable: false },
  { title: "creator.knockout.answers", columnKey: "answers", sortable: false },
  { title: "creator.knockout.actions", columnKey: "actions" },
];

export const globalCobrandListColumns = [
  { title: "administrator.categories.concept", columnKey: "name", sortable: false, filterOptions: [] },
  { title: "administrator.cobrand.table.title.tenants", columnKey: "tenants", sortable: false, filterOptions: [] },
  { title: "", columnKey: "actions" },
];

export const contractTypeColumns = [
  { title: "reference.check.candidate.contractType", columnKey: "name", sortable: false, filterOptions: [] },
  { title: "administrator.categories.localName", columnKey: "localName", sortable: false, filterOptions: [] },
  { title: "creator.knockout.actions", columnKey: "actions" },
];

export const tenantTagsCategoriesColumns = [
  { title: "administrator.categories.concept", columnKey: "name", sortable: false, filterOptions: [] },
  { title: "administrator.categories.localName", columnKey: "categoryTagLanguage['name']", sortable: false, filterOptions: [] },
  { title: "Actions", columnKey: "actions" },
];

export const integrationErrorListColumns = [
  { title: "error.logs.action", columnKey: "action", sortable: true, filterOptions: [] },
  { title: "error.logs.details", columnKey: "details", sortable: true, filterOptions: [] },
  { title: "error.logs.integration", columnKey: "integration", sortable: true, filterOptions: [] },
  { title: "error.logs.email", columnKey: "email", sortable: true, filterOptions: [] },
  { title: "error.logs.date", columnKey: "date", sortable: true, filterOptions: [] },
  { title: "error.logs.initialPayloadSent", columnKey: "initialPayloadSent", sortable: true, filterOptions: [] },
  { title: "", columnKey: "buttonReply", sortable: false, filterOptions: [] },
];

export const tenantClientStatsColumns = [
  { title: "administrator.clients.stats.header.proccess.name", columnKey: "name" },
  { title: "administrator.clients.stats.header.candidates", columnKey: "candidates" },
  { title: "administrator.clients.stats.header.pass", columnKey: "pass" },
  { title: "administrator.clients.stats.header.started", columnKey: "started" },
  { title: "administrator.clients.stats.header.inProgress", columnKey: "inProgress" },
  { title: "administrator.clients.stats.header.failed", columnKey: "failed" },
  { title: "administrator.clients.stats.header.invited", columnKey: "invited" },
];

export const tenantNotificationTemplateVarListColumns = [
  { title: "template.sms.title", columnKey: "title", sortable: true, filterOptions: [] },
  { title: "template.sms.text", columnKey: "text", sortable: true, filterOptions: [] },
  { title: "template.sms.externalId", columnKey: "externalId", sortable: false, filterOptions: [] },
  { title: "template.sms.createdAt", columnKey: "createdAt", sortable: true, filterOptions: [] },
  { title: "template.notification.language", columnKey: "language", sortable: false, filterOptions: [] },
  { title: "template.notification.type", columnKey: "type", sortable: false, filterOptions: [] },
  { title: "template.notification.updatedBy", columnKey: "updatedBy", sortable: false, filterOptions: [] },
  { title: "template.notification.subject", columnKey: "subject", sortable: false, filterOptions: [], displayed: false },
  { title: "template.notification.usage", columnKey: "usage", sortable: false, filterOptions: [] },
  { title: "", columnKey: "operation", sortable: false, filterOptions: [] },
];

export const literalsListColumns = [
  { title: "administrator.literal.key", columnKey: "key", sortable: true },
  { title: "administrator.literal.value", columnKey: "value", sortable: true },
  { title: "administrator.literal.language", columnKey: "language", sortable: false },
  { title: "Created At", columnKey: "createdAt", sortable: true },
  { title: "Updated At", columnKey: "updatedAt", sortable: true },
  { title: "Updated By", columnKey: "updatedBy", sortable: true },
  { title: "creator.knockout.actions", columnKey: "actions", sortable: false },
];

export const managenentLinksListColumns = [
  { title: "administrator.link.label", columnKey: "label", sortable: true, filterOptions: [] },
  { title: "administrator.link.link", columnKey: "link", sortable: true, filterOptions: [] },
  { title: "administrator.link.global", columnKey: "global", sortable: true, filterOptions: [] },
  { title: "creator.knockout.actions", columnKey: "actions", sortable: false, filterOptions: [] },
];

export const industryTableColumns = [
  { title: "administrator.categories.concept", columnKey: "name", sortable: true, displayed: true },
  { title: "administrator.categories.localName", columnKey: "localeName", sortable: true, displayed: true },
  { title: "creator.knockout.actions", columnKey: "actions", sortable: false, displayed: true },
];

export const additionalDocumentsTableColumns = [
  { title: "administrator.additional.document.name", columnKey: "name", sortable: true },
  { title: "administrator.additional.document.types", columnKey: "supportedTypes" },
  { title: "administrator.additional.document.ambeeType", columnKey: "ambeeType" },
  { title: "", columnKey: "actions" },
];

export const tenantScriptTableColumns = [
  { title: "creator.start.title", columnKey: "title", sortable: true },
  { title: "administrator.script.container", columnKey: "container", sortable: false },
  { title: "", columnKey: "actions" },
];

export const conversionRatesReportColumns = [
  { columnKey: "externalUserId", title: "External Candidate ID" },
  { columnKey: "jobId", title: "Job ID" },
  { columnKey: "processName", title: "Process Name" },
  { columnKey: "clientName", title: "Client" },
  { columnKey: "optout", title: "Opted Out" },
  { columnKey: "firstName", title: "Name" },
  { columnKey: "lastName", title: "Surname" },
  { columnKey: "email", title: "Email" },
  { columnKey: "zipCode", title: "Postal Code" },
  { columnKey: "phone", title: "Phone" },
  { columnKey: "createdAt", title: "Application Date" },
  { columnKey: "candidateSource", title: "Candidate Source" },
  { columnKey: "processProgressStatus", title: "Process Progress Status" },
  { columnKey: "score", title: "Overall Score" },
  { columnKey: "screeningQuestionsStatus", title: "Screening Questions Status" },
  { columnKey: "hardSkillsStatus", title: "Hard Skills Status" },
  { columnKey: "softSkillsStatus", title: "Soft Skills Status" },
  { columnKey: "videoInterviewStatus", title: "Video Interview Status" },
  { columnKey: "liveInterviewStatus", title: "Live Interview Status" },
  { columnKey: "phoneBranchInterviewStatus", title: "Phone/Branch Interview Status" },
  { columnKey: "phoneBranchInterviewTime", title: "Phone/Branch Interview Time" },
  { columnKey: "candidatePresentationStatus", title: "Candidate Presentation Status" },
];

export const candidateImportFailuresColumns = [
  { columnKey: "processId", title: "Process ID" },
  { columnKey: "processName", title: "Process Name" },
  { columnKey: "externalProcessId", title: "External Job ID" },
  { columnKey: "externalCandidateId", title: "Candidate External ID" },
  { columnKey: "importSource", title: "Import Source" },
  { columnKey: "failureId", title: "Failure Type" },
  { columnKey: "failureReason", title: "Failure Reason" },
];

export const literalDetailsColumns = [
  { columnKey: "value", title: "admin.manages.literals.value" },
  { columnKey: "translation", title: "admin.manage.literals.status" },
  { columnKey: "actions", title: "" },
];

export const literalHistoryColumns = [
  { columnKey: "selectLiterals", title: "" },
  { columnKey: "key", title: "administrator.literal.key" },
  { columnKey: "newValue", title: "admin.manages.literals.NewValue" },
  { columnKey: "previousValue", title: "admin.manages.literals.OldValue" },
  { columnKey: "date", title: "home.literals.management.modal.label.literal.updatedAt" },
  { columnKey: "language", title: "process.details.language" },
  { columnKey: "translation", title: "admin.manage.literals.status" },
  { columnKey: "fromEnvironment", title: "admin.manages.literals.propagatedFrom" },
];
